import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import { getTaxiRouteDirectory } from '../data/taxiRouteDirectory';
import '../styles/AllTaxiRoutes.css';

const PAGE_PATH = '/taxi-routes';

const AllTaxiRoutes = () => {
  const directory = useMemo(() => getTaxiRouteDirectory(), []);

  const jsonLd = useMemo(() => ([
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: 'https://easydroptaxi.com/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'All Taxi Routes',
          item: 'https://easydroptaxi.com/taxi-routes',
        },
      ],
    },
  ]), []);

  return (
    <main className="all-taxi-routes">
      <SeoHead
        title="All Taxi Routes | Easy Drop Taxi"
        description="Explore Easy Drop Taxi routes across Coimbatore, Chennai, Madurai, Trichy, Bangalore, Salem and other destinations. View route details and book your taxi."
        path={PAGE_PATH}
        jsonLd={jsonLd}
      />

      <div className="container">
        <nav className="atr-breadcrumb" aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <span aria-hidden="true">/</span>
          <span>All Taxi Routes</span>
        </nav>

        <h1>All Taxi Routes</h1>
        <p className="atr-intro">
          Explore our taxi routes across Tamil Nadu and nearby cities. Choose your route to view the route details and book your taxi.
        </p>

        <nav className="atr-jump" aria-label="Route cities">
          {directory.groups.map((group) => (
            <a key={group.id} href={`#atr-${group.id}`}>
              {group.heading.replace(' Taxi Routes', '')}
            </a>
          ))}
        </nav>

        {directory.groups.map((group) => (
          <section
            key={group.id}
            id={`atr-${group.id}`}
            className="atr-city"
            aria-labelledby={`atr-heading-${group.id}`}
          >
            <h2 id={`atr-heading-${group.id}`}>{group.heading}</h2>
            <ul className="atr-grid">
              {group.routes.map((route) => (
                <li key={`${group.id}-${route.path}`}>
                  <Link className="atr-link" to={route.path}>
                    <span>{route.origin}</span>
                    <span className="atr-arrow" aria-hidden="true">→</span>
                    <span>{route.destination}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </main>
  );
};

export default AllTaxiRoutes;
